import { CustomCard, ErrorBanner } from '@/components';
import { InlineStack, Text, SkeletonBodyText } from '@shopify/polaris';
import Switch from '@/components/Switch';
import { useState, useEffect } from 'react';
import { apiCaller } from '@/redux/api/api.caller';
import { useDispatch, useSelector } from 'react-redux';
import commonSlice from '@/redux/features/common.slice';
import { getErrorFromAPI, handleToastMutation } from '@/helpers/toast';
import { tokenSelector } from '@/redux/features/auth.slice';

const SyncStatus = () => {
  const [autoUpdateEnabled, setAutoUpdateEnabled] = useState(false);
  const [apiError, setApiError] = useState<string>('');
  const { shop } = useSelector(tokenSelector);
  const { data: syncData, isLoading: isLoadingSync } = apiCaller.useGetSyncStatusQuery();
  const [updateSyncStatus, { isLoading }] = apiCaller.useUpdateSyncStatusMutation();
  const dispatch = useDispatch();

  // Sync state với data từ server
  useEffect(() => {
    if (syncData?.data) {
      setAutoUpdateEnabled(syncData.data.isTriggerShopify);
    }
  }, [syncData]);

  const handleToggleAutoUpdate = () => {
    const newStatus = !autoUpdateEnabled;

    updateSyncStatus({
      shop: shop,
      isTriggerShopify: newStatus,
    }).then((res) => {
      if ('data' in res && res.data && res.data?.state === 1) {
        dispatch(commonSlice.actions.handleToast(handleToastMutation(res)));
        setAutoUpdateEnabled(newStatus);
        if (apiError) {
          setApiError('');
        }
        return;
      }
      setApiError(getErrorFromAPI(res));
    });
  };

  return (
    <CustomCard title="" noHeaderBorder noHeaderPaddingBottom noHeaderPadding>
      <ErrorBanner isVisible={!!apiError}>{apiError}</ErrorBanner>
      {isLoadingSync ? (
        <SkeletonBodyText lines={3} />
      ) : (
        <>
          <InlineStack align="space-between" blockAlign="center">
            <Text variant="headingMd" as="h3">
              Auto-update shipping status to Shopify
            </Text>
            <div style={{ flexShrink: 0 }}>
              <Switch
                isActive={autoUpdateEnabled}
                onClick={handleToggleAutoUpdate}
                tooltip="auto-update"
                variant="plain"
                disable={isLoading}
              />
            </div>
          </InlineStack>
          <div style={{ marginTop: '12px' }}>
            <Text variant="bodyMd" as="p" tone="subdued">
              Automatically sync shipping updates to your Shopify orders. This enables other apps to use the latest shipping
              status.
            </Text>
          </div>
        </>
      )}
    </CustomCard>
  );
};

export default SyncStatus;
